import React from 'react'
import { memo } from 'react'

import styles from './styles.module.scss'

interface BrandsAlphabetProps {
	topLetters: string[]
	hasCyrillic: boolean
	activeLetter: string | null
	isRussianActive: boolean

	onClickLetter: (letter: string) => void
	onClickRussian: () => void
}

/**
 * Отвечает только за отображение верхнего списка букв.
 * (Не-кириллические буквы + кнопка «А-Я», если есть кириллица)
 */
export const BrandsAlphabet = memo(function BrandsAlphabet(props: BrandsAlphabetProps) {
	const { topLetters, hasCyrillic, isRussianActive, onClickLetter, onClickRussian } = props

	return (
		<section className={styles['brands-alphabet']}>
			{topLetters.map(letter => (
				<button key={letter} className={styles['brands-alphabet__item']} onClick={() => onClickLetter(letter)}>
					{letter}
				</button>
			))}

			{hasCyrillic && (
				<button
					className={
						isRussianActive
							? `${styles['brands-alphabet__item']} ${styles['brands-alphabet__item--active']}`
							: styles['brands-alphabet__item']
					}
					onClick={onClickRussian}>
					А-Я
				</button>
			)}
		</section>
	)
})
